import { Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'

export default function Login() {
  const form = useForm({ email_address: '', password: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/session')
  }

  return (
    <AuthShell
      title="登录"
      subtitle="欢迎回来，继续你的习惯积分。"
      footer={
        <>
          还没有账号？<Link href="/registration/new" className="text-[#5b7cfa] font-semibold">注册</Link>
        </>
      }
    >
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label="邮箱"
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={form.data.email_address}
          error={form.errors.email_address}
          onChange={(e) => form.setData('email_address', e.target.value)}
        />
        <Field
          label="密码"
          type="password"
          autoComplete="current-password"
          required
          maxLength={72}
          value={form.data.password}
          error={form.errors.password}
          onChange={(e) => form.setData('password', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? '登录中…' : '登录'}</SubmitButton>
      </form>
      <div className="text-center">
        <Link href="/passwords/new" className="text-[#707d90] text-sm hover:text-[#5b7cfa]">忘记密码？</Link>
      </div>
    </AuthShell>
  )
}
